/**
 * What the proxy answers a server action it cannot let through, and what the
 * route error boundary recognises it by.
 *
 * A server action that meets a redirect to /login follows it, receives the
 * login page's HTML, and Next reports only "An unexpected response was
 * received from the server" — so an expired session and a momentarily
 * unreachable API looked identical to the operator, and identical to a bug.
 * Next turns a `text/plain` error body into the thrown error's message, so the
 * proxy answers with one of these and the boundary can say which it was.
 *
 * Client-safe on purpose: imported by the edge proxy and by a client component.
 */

/** The session is over (refresh token rejected or absent): sign in again. */
export const SESSION_EXPIRED_SIGNAL = 'tp:session-expired';

/** The API could not be reached to renew a live session: retry shortly. */
export const API_UNAVAILABLE_SIGNAL = 'tp:api-unavailable';
